<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-23 15:24:05
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:01:54
 * @name: 大图
 * @Description: 大图
 * @FilePath: \preSaleNafterSaleBackstage\src\components\public\big-image.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="bigImage-floating" v-if="show" @click="show = false">
    <img :src="url" @click.stop />
  </div>
</template>
<script>
import { debounceation } from "@/utils/decorator";
export default {
  name: "bigImage",
  data() {
    return {
      url: "", //图片地址
      show: false, //是否展示
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 展示图片
     * @param {String} url 图片地址
     */
    @debounceation(300)
    open(url) {
      this.url = url;
      this.show = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.bigImage-floating {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $Var-floating-color;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: auto;
  z-index: 1000;
  img {
    max-width: 80%;
    max-height: 80%;
    margin: 10%;
  }
}
</style>